<template lang="pug">
.container
  .card(:style="cardStyle", @click="(e) => { mouseClick(e); }")
    .card-content
      .columns
        .is-1
          .has-text-primary(style={ margin: '40px 15px' })
            span <b> {{ index }}. </b>
        .column
          p
            b Title :&nbsp;
            span {{ title }}
            <br>
            span #[b Publication] : {{ preprocessField(presentPlace) }} <br>
            span #[b Website] : {{ preprocessField(website) }} <br>
        .column
          p
            <b>Author(s)</b> :&nbsp;
              span(v-for="(item, index) in processedAuthors", :key="index")
                a(
                  v-if="item.bold",
                  :href="linkToProfessor",
                  target="_blank",
                  @click="markAsNotSelected"
                ) #[b {{ item.text }}]
                span(v-else) {{ item.text }}
              <br>
            span #[b Year] : {{ preprocessField(year) }}<br>
            span <b>
              span(v-if="cite != null") Cited by {{ preprocessField(cite) }} -
              | &emsp;
              a(
                v-if="linkToCitation != null",
                :href="linkToCitation",
                target="_blank",
                @click="markAsNotSelected"
              ) Link to citation
              a(v-if="apa != null", @click="showCitationData(apa)") [APA] &emsp;
              a(v-if="bibtex != null", @click="showCitationData(bibtex)") [BibTeX]
              | </b> <br>
        .is-1.is-success
          input(
            type="checkbox",
            ref='checkbox'
            :checked="selected",
            style={ width: '20px', height: '20px' }
          )
</template>
<script>
import { mapState, mapMutations } from "vuex";

export default {
  props: [
    "id",
    "index",
    "title",
    "authors",
    "presentPlace",
    "year",
    "website",
    "cite",
    "selected",
    "linkToCitation",
    "linkToProfessor",
    "apa",
    "bibtex",
  ],
  data: () => ({
    mouseDownX: 0,
    mouseDownY: 0,
    markedAsNotSelected: false,
  }),
  created() {
    window.addEventListener("mousedown", (e) => {
      this.mouseDownX = e.x;
      this.mouseDownY = e.y;
    });
  },
  computed: {
    ...mapState("fetchPaper", {
      searchedProfName: (s) => s.searchedProfName,
    }),
    processedAuthors() {
      const result = [];
      //min prof name
      const profNameSplited = this.searchedProfName.split(" ");
      const profFirstNameChar = profNameSplited[0][0];
      const profLastName = profNameSplited[1];
      const profMinName = profFirstNameChar + " " + profLastName;

      const splited = this.authors.split(profMinName);

      //no prof min name in entire authors text
      if (splited.length === 1) {
        result.push({ text: splited[0], bold: false });
      } else {
        result.push({ text: splited[0], bold: false });
        result.push({ text: profMinName, bold: true });
        result.push({ text: splited[1], bold: false });
      }
      return result;
    },
    cardStyle() {
      if (this.selected)
        return "margin-bottom: 0.8rem; border: 3px solid #896bda;";
      else return "margin-bottom: 0.8rem";
    },
  },
  methods: {
    ...mapMutations("fetchPaper", ["toggleSelectPaperRecord"]),
    mouseClick(e) {
      if (e.x === this.mouseDownX && e.y === this.mouseDownY) {
        if (this.markedAsNotSelected === false) {
          this.toggleSelectPaperRecord(this.id);
        } else {
          this.markedAsNotSelected = false;
        }
      }else{
        //prevent checkbox native state
        this.$nextTick(()=>{
          this.$refs.checkbox.checked=this.selected
        })
      }
    },
    preprocessField(fieldContent) {
      return fieldContent ?? "-";
    },
    showCitationData(citeData) {
      this.openMessageBox(citeData);
      this.markedAsNotSelected = true;
    },
    markAsNotSelected() {
      this.markedAsNotSelected = true;
    },
  },
};
</script>